import axios from "axios";

const state = {
  usuarios: null,
  usuarioSeleccionado: null,
  mensaje: ""
};

const getters = {
  usuarios: (state) => state.usuarios,
  usuarioSeleccionado: (state) => state.usuarioSeleccionado,
};

const mutations = {
  setUsuarios: (state, usuarios) => {
    state.usuarios = usuarios;
  },
  setUsuarioSeleccionado: (state, usuarioSeleccionado) => {
    state.usuarioSeleccionado = usuarioSeleccionado;
  },
  setMensaje: (state, mensaje) => {
    state.mensaje = mensaje;
  }
};

const actions = {
  async consultar({ commit }) {
    try {
      const res = await axios.get(`/v1/usuarios`);
      commit("setUsuarios", res?.data?.result);
    } catch (error) {
      commit("setUsuarios", []);
      return error;
    }
  },
  async crear({ commit, state }, data) {
    try {
      let res = await axios.post(`/v1/usuarios`, data);
      let nuevo = res?.data?.result;
      let actualizados = [...state.usuarios, nuevo];
      commit("setUsuarios", actualizados);
      commit("setMensaje", "Usuario creado con éxito");
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Error al crear el usuario";
      throw new Error(errorMessage);
    }
  },
  async editar({ commit }, data) {
    try {
      await axios.put(`/v1/usuarios/${data.id}`, data.data);
      commit("setMensaje", "Usuario editado con éxito");
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Error al editar el usuario";
      throw new Error(errorMessage);
    }
  },
  async eliminar({ commit, state }, data) {
    try {
      let res = await axios.delete(`/v1/usuarios/${data.id}`);
      let copia = state.usuarios;
      const filtrados = copia.filter(
        (item) => item.id !== res?.data?.result?.id
      );
      commit("setUsuarios", filtrados);
    } catch (error) {
      return error;
    }
  },
  async crearUsuarioVehiculoTransporte({ commit }, data) {
    try {
      await axios.post(`/v1/usuario-bodega/crear`, data);
      commit("setMensaje", "Usuario creado con éxito");
    } catch (error) {
      return error;
    }
  },
  async cambiarClave({ commit }, data) {
    try {
      await axios.put(`/v2/usuarios/cambiar-clave`, data);
      commit("setMensaje", "Cambio de clave con éxito");
    } catch (error) {
      return "ERROR";
    }
  },
  async consultarVehiculosTecnicos({ commit }) {
    try {
      const [res1, res2] = await Promise.all([
        axios.get(`/v1/usuarios/bodega-vehiculos/vehiculos`),
        axios.get(`/v1/usuarios/bodega-tecnicos/tecnicos`),
      ]);
      const res = [...res1?.data?.result, ...res2?.data?.result];
      commit("setUsuarios", res);
    } catch (error) {
      commit("setUsuarios", []);
      return error;
    }
  },
  async eliminarVehiculoTecnico({ commit }, data) {
    try {
      switch (data.rol) {
        case "ROLE_TECNICO":
          await axios.delete(`v1/usuarios/bodega-tecnicos/${data.id}/tecnicos`);
          break;
        case "ROLE_TRANSPORTE":
          await axios.delete(`v1/usuarios/bodega-vehiculos/${data.id}/vehiculos`);
          break;
        default:
          throw new Error("Rol no válido");
      }
      const [res1, res2] = await Promise.all([
        axios.get(`/v1/usuarios/bodega-vehiculos/vehiculos`),
        axios.get(`/v1/usuarios/bodega-tecnicos/tecnicos`),
      ]);
      const res = [...res1?.data?.result, ...res2?.data?.result];
      commit("setUsuarios", res);
      return "Eliminación exitosa";
    } catch (error) {
      return "No se pudo realizar la eliminación";
    }
  },
  async resetPassword({ commit }, data) {
    try {
      await axios.post(`/v2/usuarios/recuperar-clave`, data);
      commit("setMensaje", "Clave reseteada con éxito");
    } catch (error) {
      return error;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
